import React from 'react';
import styled from "styled-components";
// import ScrollingColorBackground from 'react-scrolling-color-background';

const darkPurpleRgb = 'rgb(101, 45, 172)'
const ceriseRgb = 'rgb(217, 38, 136)'
const pumpkinRgb = 'rgb(255, 102, 22)'
const cornRgb = 'rgb(254, 201, 64)'
const greenRgb = 'rgb(29, 191, 104)'
const tealRgb = 'rgb(32, 202, 172)'
const skyRgb = 'rgb(60, 191, 246)'
const blueRgb = 'rgb(10, 34, 236)'
const COLORS = [
    skyRgb,
    tealRgb,
    ceriseRgb,
    pumpkinRgb,
    cornRgb,
    greenRgb,
    blueRgb,
    darkPurpleRgb,
];

const SECTIONS = [
    skyRgb,
]

const StyledContentWrapper = styled.div`
//color:white
`


const Contents = () => {
    return <div>
        {SECTIONS.map((rgbString, idx) => (
            <StyledContentWrapper
                key={idx}
                className='js-color-stop'
                data-background-color={rgbString}
                style={{height: '100vh'}}
            >
                Hi
            </StyledContentWrapper>
        ))}
    </div>
};

export default Contents;



// WEBPACK FOOTER //
// ./src/components/Sections/Content.js